<section [style]="styles" class="label-{{ titlePosition }}">
  @if (labelEnabled) {
    <blaze-element-label
      [color]="props?.style?.general?.title?.color1"
      [extendInputPadding]="elementContext?.extendInputPadding"
      [fontFamily]="props?.style?.labelBlock?.fontFamily"
      [fontSize]="props?.style?.labelBlock?.fontSize"
      [fontStyle]="props?.style?.labelBlock?.fontStyle"
      [fontWeight]="props?.style?.labelBlock?.fontWeight"
      [horizontalAlign]="props?.content?.title?.align"
      [icon]="props?.content?.title?.icon"
      [iconColor]="props?.content?.title?.iconColor?.color1"
      [iconPosition]="props?.content?.title?.iconPosition"
      [iconSize]="props?.style?.labelBlock?.iconSize"
      [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
      [lineHeight]="props?.style?.labelBlock?.lineHeight"
      [position]="props?.content?.title?.position"
      [tooltip]="props?.content?.title?.tooltip"
      [width]="props?.content?.title?.width"
    >
      {{ labelText }}
    </blaze-element-label>
  }

  <div class="input" [style]="inputStyles" [class.validation-error]="hasValidationError">
    <blaze-checkbox
      #checkbox
      checkboxStyle="bat"
      class="{{ elementKeyRoot }} {{ elementKey }}"
      [checked]="value ?? null"
      [readonly]="isReadonly"
      (change)="onChange($event)"
    />
  </div>
</section>

@if (hasValidationError) {
  <div class="validation" [style]="validationStyles">
    {{ formState?.messages?.required || formState?.messages?.invalid || '' }}
  </div>
}
